module.exports = __webpack_public_path__ + "static/media/notifications.9007182b.png";